import axios from 'axios'
import currency from "currency.js";
import {stringify} from 'qs'
import {get} from "cart-localstorage";

const api = axios.create({
    baseURL: GG.actionUrl,
    headers: {
        'X-CSRF-Token': GG.csrfTokenValue
    },
    transformRequest: [
        function (data) {
            return stringify(data)
        }
    ]
})

let NonprofitsIndex = Garnish.Base.extend({
    $form: null,
    $allInputs: null,
    $categoriesInputs: null,
    $countiesInputs: null,
    $sizesInputs: null,
    $tagsInputs: null,
    $frontendTagsInputs: null,
    $hasNotMetGoalInput: null,

    $clearCategoriesButton: null,
    $clearCountiesButton: null,
    $clearSizesButton: null,
    $clearTagsButton: null,
    $clearFrontendTagsButton: null,
    $resetFilterButton: null,

    tagify: 0,

    $mobileFilterTrigger: null,
    $triggerText: null,
    $filterCountContainer: null,
    filterCount: 0,

    categories: [],
    counties: [],
    sizes: [],
    tags: [],
    frontendTags: [],
    hasNotMetGoal: 'off',

    init() {
        this.$form = $('#nonprofit-filter')
        this.$allInputs = this.$form.find('input')
        this.$categoriesInputs = this.$form.find('.category-input')
        this.$countiesInputs = this.$form.find('.county-input')
        this.$sizesInputs = this.$form.find('.size-input')
        this.$tagsInputs = this.$form.find('.tag-input')
        this.$frontendTagsInputs = this.$form.find('.frontendtag-input')
        this.$hasNotMetGoal = this.$form.find('.hasNotMetGoal-input')

        this.$clearCategoriesButton = $('.clear-categories')
        this.$clearCountiesButton = $('.clear-counties')
        this.$clearSizesButton = $('.clear-sizes')
        this.$clearTagsButton = $('.clear-tags')
        this.$clearFrontendTagsButton = $('.clear-frontend-tags')
        this.$resetFilterButton = $('.reset-filters')

        this.$mobileFilterTrigger = $('.mobile-filter-trigger')
        this.$truggerText = this.$mobileFilterTrigger.find('.trigger-text')
        this.$filterCountContainer = this.$mobileFilterTrigger.find('.filter-count')

        // Initialize query array
        this.checkQuery()

        this.addListener(this.$allInputs, 'change', this.buildUrlQuery)
        this.addListener(this.$resetFilterButton, 'click', this.resetFilter)
        this.addListener(this.$clearCategoriesButton, 'click', this.clearCategories)
        this.addListener(this.$clearCountiesButton, 'click', this.clearCounties)
        this.addListener(this.$clearSizesButton, 'click', this.clearSizes)
        this.addListener(this.$clearTagsButton, 'click', this.clearTags)
        this.addListener(this.$clearFrontendTagsButton, 'click', this.clearFrontendTags)
        this.addListener(this.$mobileFilterTrigger, 'click', this.toggleMobileFilters)

        this._updateFilterCount()

        api.get('gg/nonprofits/get-frontend-tags').then($.proxy(function (res) {
            this.frontendTags.forEach($.proxy(function (el) {
                let found = res.data.find((item) => item.slug === el)
                this.$frontendTagsInputs.val(this.$frontendTagsInputs.val() + ', ' + found.value)
                // this.tagify.addTags(found.value)
            }, this))

            this.tagify = new Tagify(this.$frontendTagsInputs[0], {
                whitelist: res.data,
                enforceWhitelist: true,
                editTags: false,
                maxTags: 10,
                dropdown: {
                    maxItems: 20,           // <- mixumum allowed rendered suggestions
                    classname: "tags-look", // <- custom classname for this dropdown, so it could be targeted
                    enabled: 0,             // <- show suggestions on focus
                    closeOnSelect: true    // <- do not hide the suggestions dropdown once an item has been selected
                }
            })
        }, this))
    },

    checkQuery() {
        let categories = this._getUrlParams('categories')
        let counties = this._getUrlParams('counties')
        let sizes = this._getUrlParams('sizes')
        let tags = this._getUrlParams('tags')
        let frontendTags = this._getUrlParams('frontendTags')
        let hasNotMetGoal = this._getUrlParams('hasNotMetGoal')

        if (categories) {
            this.categories = categories.split(',')
        }

        if (counties) {
            this.counties = counties.split(',')
        }

        if (sizes) {
            this.sizes = sizes.split(',')
        }

        if (tags) {
            this.tags = tags.split(',')
        }

        if (frontendTags) {
            this.frontendTags = frontendTags.split(',')
        }

        if (hasNotMetGoal) {
            this.hasNotMetGoal = hasNotMetGoal
        }

        this.filterCount = this.categories.length + this.counties.length + this.sizes.length + this.tags.length + this.frontendTags.length + this.hasNotMetGoal.length

        this._updateFilterCount()
    },

    buildUrlQuery(e) {
        this.categories = []
        this.$categoriesInputs.each($.proxy(function (i, item) {
            if ($(item).is(':checked')) {
                this.categories.push($(item).val())
            }
        }, this))

        this.counties = []
        this.$countiesInputs.each($.proxy(function (i, item) {
            if ($(item).is(':checked')) {
                this.counties.push($(item).val())
            }
        }, this))

        this.sizes = []
        this.$sizesInputs.each($.proxy(function (i, item) {
            if ($(item).is(':checked')) {
                this.sizes.push($(item).val())
            }
        }, this))

        this.tags = []
        this.$tagsInputs.each($.proxy(function (i, item) {
            if ($(item).is(':checked')) {
                this.tags.push($(item).val())
            }
        }, this))

        this.frontendTags = []
        if ($(this.$frontendTagsInputs).val() !== '') {
            const frontEndItems = JSON.parse($(this.$frontendTagsInputs).val())
            for (let i = 0; i < frontEndItems.length; i++) {
                this.frontendTags.push(frontEndItems[i].slug)
            }
        }

        this.hasNotMetGoal = []
        this.$hasNotMetGoal.each($.proxy(function (i, item) {
            if ($(item).is(':checked')) {
                this.hasNotMetGoal = 'on'
            }
        }, this))

        let url = GG.siteUrl + `nonprofits?categories=${this.categories.join(',')}&counties=${this.counties.join(',')}&sizes=${this.sizes.join(',')}&frontendTags=${this.frontendTags.join(',')}&tags=${this.tags.join(',')}&hasNotMetGoal=${this.hasNotMetGoal}`

        // If interacting with search tags, wait till it closes
        // if ($(e.currentTarget).hasClass('frontendtag-input')) {
        //     console.log('Tags: ', e)
        // } else {
        history.pushState({}, '', url)
        window.location = url
        // }


    },

    resetFilter(e) {
        e.preventDefault()
        window.location = GG.siteUrl + `nonprofits`
    },

    clearCategories(e) {
        e.preventDefault()
        let url = window.location.href
        let urlParts = url.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('categories')
        let newUrl = urlParts[0] + '?' + params.toString()
        history.pushState({}, '', newUrl)
        window.location = newUrl
    },

    clearCounties(e) {
        e.preventDefault()
        let url = window.location.href
        let urlParts = url.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('counties')
        let newUrl = urlParts[0] + '?' + params.toString()
        history.pushState({}, '', newUrl)
        window.location = newUrl
    },

    clearSizes(e) {
        e.preventDefault()
        let url = window.location.href
        let urlParts = url.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('sizes')
        let newUrl = urlParts[0] + '?' + params.toString()
        history.pushState({}, '', newUrl)
        window.location = newUrl
    },

    clearTags(e) {
        e.preventDefault()
        let url = window.location.href
        let urlParts = url.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('tags')
        let newUrl = urlParts[0] + '?' + params.toString()

        this.clearHasNotMetGoal(newUrl)
    },

    clearFrontendTags(e) {
        e.preventDefault()
        let url = window.location.href
        let urlParts = url.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('frontendTags')
        let newUrl = urlParts[0] + '?' + params.toString()
        history.pushState({}, '', newUrl)
        window.location = newUrl
    },

    clearHasNotMetGoal(newUrl) {
        let urlParts = newUrl.split('?')
        let params = new URLSearchParams(urlParts[1])
        params.delete('hasNotMetGoal')
        let newNewUrl = urlParts[0] + '?' + params.toString()
        history.pushState({}, '', newNewUrl)
        window.location = newNewUrl
    },

    toggleMobileFilters(e) {
        e.preventDefault()

        if (this.$form.is(':visible')) {
            this.$truggerText.html('Show Options')
            this.$form.slideUp()
        } else {
            this.$truggerText.html('Hide Options')
            this.$form.slideDown()
        }
    },

    _updateFilterCount() {
        this.$filterCountContainer.html(this.filterCount)
    },

    _getUrlParams(params) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === params) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }

        return false;
    }
})

let NonprofitItem = Garnish.Base.extend({
    $element: null,

    // Elements
    isMinimal: false,

    // Entry
    entryId: null,
    userId: null,
    octPartner: false,
    octOrganization: false,
    categoryId: false,
    categoryName: false,
    contactAboutVolunteering: false,

    // Donation Form
    $donationForm: null,
    $addToCartButton: null,
    $donationAmountInput: null,

    // Favorite
    $favoriteTrigger: null,
    favorited: false,

    init(el) {
        this.$element = $(el)

        // Elements
        this.isMinimal = $('.page-myaccount').length

        // Entry
        this.entryId = this.$element.data('entry-id')
        this.userId = this.$element.data('user-id') ? this.$element.data('user-id') : false
        this.octPartner = !!this.$element.data('oct-partner')
        this.octOrganization = !!this.$element.data('oct-organization')
        this.categoryId = this.$element.data('category-id')
        this.categoryName = this.$element.data('category-name')
        this.contactAboutVolunteering = this.$element.data('contact-about-volunteering')

        // Donation
        this.$donationForm = this.$element.find('.donation-form')
        this.$addToCartButton = this.$donationForm.find('button')
        this.$donationAmountInput = this.$donationForm.find('input')
        this.addListener(this.$donationForm, 'submit', this.handleAddToCart)
        this.addListener(this.$addToCartButton, 'click', this.handleAddToCart)

        // Favorite Item
        this.$favoriteTrigger = this.$element.find('.favorite-trigger')
        this.favorited = this.$element.data('favorited')

        this.addListener(this.$favoriteTrigger, 'click', this.handleFavoriteItem)
    },

    handleFavoriteItem(e) {
        e.preventDefault()
        let self = this

        if (this.userId) {
            api.post('gg/nonprofits/favorite-nonprofit', {
                entryId: this.entryId,
                userId: this.userId
            })
                .then(function (res) {
                    if (res.data.favorited) {
                        self.$favoriteTrigger.addClass('liked')
                        toastr.info('Added to favorites')
                    } else {
                        self.$favoriteTrigger.removeClass('liked')
                        toastr.warning('Removed from favorites')
                        if (self.isMinimal) {
                            self.$element.velocity({opacity: 0}).velocity('slideUp')
                        }
                    }
                })
                .catch(function (error) {
                    console.log('error', error)
                })

        } else {
            toastr.warning('Please create an account to save your favorite nonprofits.')
        }
    },

    handleAddToCart(e) {
        e.preventDefault()
        let amount = parseInt(this.$donationAmountInput.val())
        let result = (amount - Math.floor(amount)) !== 0;

        if (!amount || amount < 10) {
            toastr.error('Minimum $10 is required')
            Garnish.shake(this.$donationForm);
        } else if (result) {
            toastr.error('Positive integers are required')
            this.$donationAmountInput.val(amount.toFixed())
            Garnish.shake(this.$donationForm);
        } else {
            // Add item to cart
            GG.Cart.addItemToCart({
                id: this.entryId,
                userId: this.userId,
                price: amount,
                nonprofit: {
                    id: this.entryId,
                    name: this.$element.data('nonprofit-title'),
                    url: this.$element.data('nonprofit-url'),
                    email: this.$element.data('nonprofit-email'),
                    taxId: this.$element.data('nonprofit-taxid'),
                    categoryId: this.categoryId,
                    categoryName: this.categoryName,
                    octPartner: this.octPartner,
                    octOrganization: this.octOrganization,
                    favorited: !!this.$element.data('user-id'),
                    contactAboutVolunteering: !!this.$element.data('contact-about-volunteering'),
                }
            })

            // Update Counter
            GG.Cart.updateCartTotalAmount()

            toastr.info(`${currency(amount).format()} added to cart`)
        }
    },
})

Garnish.$doc.ready(function () {
    if ($('.page-nonprofits').length > 0) {
        GG.NonprofitsIndex = new NonprofitsIndex()
    }

    if ($('.nonprofit-item').length > 0) {
        $('.nonprofit-item').each(function (i, el) {
            new NonprofitItem(el)
        })
    }
})
































